import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Select} from "antd";
import {debounce} from "lodash/function";
import {getAllEmployeeReferencesHasAccountFound} from "../../../../../api/hrm/personel/api";
import {t} from "i18next";

const {Option, OptGroup} = Select;

const SelectDepartmentJobPositionEmployee = ({placeholder,type,name, notFoundContent, ...rest}) => {
    const [data, setData] = useState([]);

    const mapData = (data = []) => {
        if (!data || data.length <= 0) return [];
        return data?.map(item => ({
            label: (
                <div>
                    {item?.name}
                    <span className={"text-gray-400"}>{item?.type === "employee"
                        ? ` @${item?.screenName}`
                        : ""}</span>
                </div>
            ),
            value: `${item.id}/${item.externalReferenceCode}/${item.type}`,
            key: `${item.id}/${item.externalReferenceCode}/${item.type}`,
            disabled: item?.status === "trashed",
            data: item
        }));
    }

    const mapDataForAll = () => {
        return [{
            label: (
                <div>
                    {t("tnp.components.objectAssign.allMember")}
                </div>
            ),
            value: `${-1}/for-all-company/all`,
            key: `${-1}/for-all-company/all`
        }];
    }

    const mapDataDuplicate = (data = []) => {
        if (!data || data.length <= 0) return [];
        return data?.flatMap(item => {
            return [
                {
                    label: (
                        <div>
                            {item?.name}
                        </div>
                    ),
                    value: `${item.id}/${item.externalReferenceCode}/${item.type}`,
                    key: `${item.id}/${item.externalReferenceCode}/${item.type}`
                },

            ]
        });
    }

    const setDataOptions = (data) => {
        setData([
            {
                key: "all",
                label: <p className={"font-medium"}>
                    {t("tnp.components.objectAssign.all")}
                </p>,
                options: mapDataForAll(),
            },
            {
                key: "department",
                label: <p className={"font-medium"}>
                    {t("tnp.components.objectAssign.department")}
                </p>,
                options: mapData(data?.filter(item => item?.type === "department")),
            },
            {
                key: "title",
                label: <p className={"font-medium"}>
                    {t("tnp.components.objectAssign.jobTitle")}
                </p>,
                options: mapDataDuplicate(data?.filter(item => item?.type === "title")),
            },
            {
                key: "position",
                label: <p className={"font-medium"}>
                    {t("tnp.components.objectAssign.jobPosition")}
                </p>,
                options: mapDataDuplicate(data?.filter(item => item?.type === "position")),
            },
            {
                key: "employee",
                label: <p className={"font-medium"}>
                    {t("tnp.components.objectAssign.employee")}
                </p>,
                options: mapData(data?.filter(item => item?.type === "employee")),
            },
        ].filter(item => type?.includes(item.key) || type === undefined));
    }

    function initialOptions() {
        getAllEmployeeReferencesHasAccountFound(null,
            1,
            100,
            null, null).then((response) => {
            setDataOptions(response?.items);
            const dataForm = rest?.form?.getFieldValue(name)

            if (response?.items?.length === dataForm?.filter(item => item?.split("/")[3] !== "same")?.length) {

                rest?.form?.setFieldValue(name, [`${-1}/for-all-company/all`, ...dataForm])
            }
        }).catch(() => {
        });
    }

    const handleChangeSelect = (value) => {
           const newItem = value?.filter(item => item?.split("/")[2] === "all")
           const preValue = rest?.form?.getFieldValue(name)?.filter(item => item?.split("/")[2] === "all")
           if (newItem && newItem?.length > 0) {
               // select all

               if (preValue && preValue?.length > 0) {
                   // unselect other
                   rest?.form?.setFieldValue(name, value?.filter(item => item?.split("/")[2] !== "all"))
               } else {
                   // select all

                   const dataFlat = data?.map(obj => obj.options).flat()
                   const newValue = dataFlat?.map(item => item?.value)

                   rest?.form?.setFieldValue(name, newValue)
               }
           } else if (preValue && preValue?.length > 0) {
               // unselect all

               rest?.form?.setFieldValue(name, [])
           } else {
               // select normal

               rest?.form?.setFieldValue(name, value)
           }
    }

    useEffect(() => {
        initialOptions();
    }, [rest?.form?.getFieldValue(name)])

    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
        const loadOptions = (search) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setData([]);
            if (search !== "" && search !== null) {
                getAllEmployeeReferencesHasAccountFound(null,
                    null,
                    null,
                    search, null).then((response) => {
                        if (fetchId !== fetchRef.current) {
                            return;
                        }
                        setDataOptions(response?.items);
                    }
                ).catch(() => {
                });
            } else
                initialOptions();
        };

        return debounce(loadOptions, 400);
    }, []);

    function NotFoundContent(props) {
        return (
            <div className={"text-center text-black py-[30px] px-[40px]"}>
                <p className={"mb-2 font-[600] leading-[24px]"}>{t("tnp.components.objectAssign.notFound")}</p>
                <p className={"text-[14px] font-[400] leading-[20px]"}>{t("tnp.components.objectAssign.tryAgain")}</p>
            </div>
        );
    }

    return (

                    <Select
                        placeholder={placeholder}
                        notFoundContent={notFoundContent || <NotFoundContent/>}
                        allowClear={true}
                        showSearch={true}
                        filterOption={false}
                        onSearch={debounceFetcher}
                        onBlur={initialOptions}
                        dropdownStyle={{
                            padding: "12px"
                        }}
                        maxTagCount={10}
                        onChange={handleChangeSelect}
                        {...rest}
                    >
                        {data?.map((group) => (
                            group?.options?.length > 0 && (
                                <OptGroup label={group?.label} key={group?.key}>
                                    {group?.options?.map((option) => (
                                        <Option data={option?.data}
                                                value={option?.value}
                                                key={option?.key}
                                                disabled={option?.disabled}
                                        >
                                            {option?.label}
                                        </Option>
                                    ))}
                                </OptGroup>
                            )
                        ))}
                    </Select>

    );
}

export default SelectDepartmentJobPositionEmployee;
